<template>
    <div class="animated fadeIn"> 
      <b-row>
        <b-col sm="12"> 
          <b-card>
              
              <div slot="header" class="d-flex justify-content-between align-items-center">
                <strong>MISReport Load Wise </strong>
                  <b-button variant="primary" @click="redirectNewPage">
                  Click To Redirect Old Page              
                    </b-button>
              </div>       
            <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">  
              <b-row>  
                <b-col sm="7">
                  <div id='container'>
                    <b-form-group label="Warehouse ID" :label-cols="3">
                    <div id='container'>
                      <ejs-multiselect  id='multi_select2'  placeholder="Select WareHouse" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                      ></ejs-multiselect>
                  </div>    
                    </b-form-group>
                  </div>
                </b-col>          
              </b-row>          
              <b-row>  
                <b-col sm="4">
                  <b-form-group label="Shipment Status:"  :label-cols="5" >
                    <b-form-select v-model="shipmentstatus" name="shipmentstatus" class="mySelectBox">
                      <option :value="selected">--Selected Status-</option>
                  
                      <option value="BookingPending">Booking Pending</option>
                      <option value="NDR">NDR</option>
                      <option value="INTransit">IN Transit</option>
                      <option value="Delivered">Delivered</option>
                      <option value="BookingDone">Booking Done</option>
                      <option value="OFD">OFD</option>
                      <option value="partialDLV">Partial Delivered</option>
                      
  
                    </b-form-select>                                
                  </b-form-group>                   
                </b-col>    
                <b-col sm="4">
                    <b-col sm="12">
                      <b-form-group label="From Date:"  :label-cols="4" >
                        <v-date-picker
                          mode="single"
                          input-class="dateInput"
                          :available-dates="{ start: null, end: new Date() }"
                          v-model="selectDateFrom"
                        />
                      </b-form-group>
                    </b-col>
                </b-col>
                
                 <b-col sm="4">
                  <b-form-group label="To Date:"  :label-cols="4" >
                      <v-date-picker
                        mode="single"
                        input-class="dateInput"
                         :available-dates="{
                            start: selectDateFrom,
                            end: getMaxToDate()
                          }"
                        v-model="selectDateTo"
                      />
                  </b-form-group>
                </b-col>
                 <b-col md="4" class="my-1">
                  <b-form-group >                           
                    <b-form-textarea v-model.trim="searching" style="height:100px" placeholder="Type to Search : 1023,Test" @input="checklenght(searching)"></b-form-textarea>                                           
                  </b-form-group>
                  <div>
                    <span style="color:red">Note:For Multiple Search Use comma(,) Separator </span>
                  </div>
                </b-col>
  
                <b-col md="4" class="my-1">
                  <!-- <b-col sm="12"> -->
                    <b-form-group label="Select Load Movement:"  :label-cols="6" >
                      <b-form-select
                      v-model="selected_normalorasn"
                      :options="mpsloadoptions"
                      class="mb-3"
                      value-field="value"
                      text-field="text"
                      ></b-form-select>
                    </b-form-group>
                    <!-- </b-col> -->
              </b-col>
  
                <b-col md="4" class="my-1 text-right">               
                  <b-form-group>
                   <b-button type="submit" size="md" variant="primary" @click="showLoadwise(1)"> Search</b-button>
                 
                    <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10px"> clear</b-button>
                   
                    <b-button v-if="totalRows>0" type="submit" variant="primary" size="md" style="margin-left:20px;" @click="downloadCSV">Download </b-button>
                   
                  </b-form-group>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="12" class="text-right  margin-bottom =-13px;" >
                  <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b>   &nbsp;&nbsp;&nbsp;
                </b-col>
              </b-row> 
            </b-form>         
          
            <b-col sm="12" style="overflow:auto;">  
              <b-table show-empty  responsive :busy="isBusy"   :items="items" :fields="fields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered"  > 
                  
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  <template slot="markdeliverystatusflag" slot-scope="row">
                    <span v-if="row.item.markdeliverystatusflag == '1'">
                      Yes
                    </span>
                    <span v-else>
                      No
                    </span>
                  </template>
                  <template slot="calulatededd" slot-scope="row">
                    <div>
                        {{ row.item.calulatededd }}
                    </div>
                </template>
              </b-table>
            </b-col>
  
            <b-col md="12" class="my-1" v-if="totalRows>0">
              <paginate v-model="pageNum" :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
              </paginate>
            </b-col>
          </b-card>
        </b-col>
      </b-row>    
    </div>
  </template>
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from 'vue'
  export default {
    data: function() {
      return {
        data: [], 
        items:[],    
        selected:'',
        isBusy: false,   
       
        data1:[],
        // perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: true,
     
           selectedDate: new Date(),

        selectDateFrom: new Date(),
        selectDateTo:new Date(),
        
        fields: [
            { key: 'whid', label: 'WH ID', sortable: true, sortDirection: 'desc' },
            { key: 'warehousename', label: 'WH Name', sortable: true, sortDirection: 'desc' },
            { key: 'userid', label: 'User ID', sortable: true, sortDirection: 'desc' },
            { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
            { key: 'invoiceno', label: 'Load Id', sortable: true, sortDirection: 'desc' },
            { key: 'accounttype', label: 'Account Type',sortable: true, sortDirection: 'desc' },
            { key: 'assigneddate', label: 'Assigned Date', sortable: true, sortDirection: 'desc' },
            { key: 'invoicevalue', label: 'Invoice Value', sortable: true, sortDirection: 'desc' },
            { key: 'mpscount', label: 'MPS Count', sortable: true, sortDirection: 'desc' },
            { key: 'actualweight', label: 'Actual Weight', sortable: true, sortDirection: 'desc' },
            { key: 'volumetricweight', label: 'Volumetric Weight', sortable: true, sortDirection: 'desc' },
            { key: 'deliverystatus', label: 'Delivery Status', sortable: true},
            { key: 'shipmentstatus', label: 'Shipment Status', sortable: true},
            { key: 'hub_title', label: 'Hub Name', sortable: true},
            { key: 'zone_title', label: 'Zone Name', sortable: true},
            { key: 'vehicleno', label: 'Vehicle No.', sortable: true, sortDirection: 'desc' },
            { key: 'transportername', label: 'Transporter Name', sortable: true, sortDirection: 'desc' },
            { key: 'vehiclename', label: 'Vehicle Name', sortable: true, sortDirection: 'desc' },
            { key: 'origincity', label: 'Origin City', sortable: true},
            { key: 'originstate', label: 'Origin State', sortable: true},
            { key: 'destinationcity', label: 'Destination City', sortable: true, sortDirection: 'desc' },
            { key: 'destinationstate', label: 'Destination State', sortable: true, sortDirection: 'desc' },
            { key: 'companyname', label: 'Company Name', sortable: true, sortDirection: 'desc' },
            { key: 'markdeliverystatusflag', label: 'Manual Delivery', sortable: true, sortDirection: 'desc' },
            { key: 'ofddate', label: 'OFD Date', sortable: true},
            { key: 'deliverydate', label: 'Delivery Date', sortable: true},
            { key: 'ebn', label: 'EBN No.', sortable: true},
            { key: 'ebnexpirydate', label: 'Expiry Date', sortable: true},
            { key: 'lastmodifiedat', label: 'Last Modified At', sortable: true},
            { key: 'lastmodifieddate', label: 'Last Modified Date', sortable: true},
            { key: 'lastmodifiedby', label: 'Last Modified By', sortable: true },
            { key: 'calulatededd', label: 'EDD', sortable: true},
          ],
          bordered: true,
          totalRows: 0,
          currentPage: 1,
          perPage:  20,
          pageOptions: [5, 10, 15],
          sortBy: null,
          sortDesc: false,
          sortDirection: 'asc',
          filter: null,
          valueWH:[],
          fieldWH:{ text: 'name', value: 'id' },
          optionsWH:[],
          WHData:[],
          showSelectAll : true,
          shipmentstatus:'',
          pageNum:1,
          noofpages:'',
          pageOptions: [5, 10, 15],
          sortBy: true,
          searching:[],
          searchvaluesarr:[],
          user_type:'',
          sysusermasterid:'',
          selected_normalorasn : 'rocketbees',
          mpsloadoptions: [
            { value: 'rocketbees', text: 'RocketBees' },
            { value: 'rocketbees_vendor', text: 'RocketBees Vendor' }]
          
      };
    },
   watch: {
        selectDateFrom(val) {
          if (!val) return;

          // max allowed to date = from + 40 days
          const maxToDate = new Date(val);
          maxToDate.setDate(maxToDate.getDate() + 40);

          // if current ToDate exceeds limit → adjust
          if (this.selectDateTo > maxToDate) {
            this.selectDateTo = maxToDate;
          }
        },

        selectDateTo(val) {
          if (!val || !this.selectDateFrom) return;

          const minFromDate = new Date(val);
          minFromDate.setDate(minFromDate.getDate() - 40);

          // if FromDate is too old → adjust
          if (this.selectDateFrom < minFromDate) {
            this.selectDateFrom = minFromDate;
          }
        }
      },
    created: function() {
     
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // this.email=userInfo.sysemailid;
  
      this.showLoadwise(this.pageNum);
      this.showWHlist();
    },
    methods: {
    redirectNewPage() {
        window.open('/Misreport_loadwise_modified', '_blank'); // opens in new tab
    },
       getMaxToDate() {
          if (!this.selectDateFrom) return new Date();

          const max = new Date(this.selectDateFrom);
          max.setDate(max.getDate() + 40);

          // cannot exceed today
          return max > new Date() ? new Date() : max;
        },
      checklenght(value){
          console.log("value",value)
          if (value.length==0) {
            this.searching=[]
            this.totalRows=0
            this.showLoadwise(this.pageNum)
          }
        },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      validateForm(scope) {},
      clickCallback (pageNum)
         {
  
        this.showLoadwise(pageNum);
      },
      
      showLoadwise: function(page) {
        this.items  = [];
                this.totalRows = 0;     
        var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
        
            this.isBusy = true;
          //date
          var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
          var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
  
  console.log('fromdate',fromdate)
    console.log('formatdateto',formatdateto)

          if(formatdateto< fromdate){  
             this.$fire({
                    text:"To date need to be greater than From date",
                    type: "warning",
                    timer: 30000
                  }); 
                  this.isBusy = false; 
                  return false;       
          }
          //warehouse id and shipmentstatus
          var warehouseid=(this.valueWH.length>0)? this.valueWH:"";
          var shipmentstatus=(this.shipmentstatus!=null)?this.shipmentstatus:"";
  
          //search
          if (this.searching!= "") {
              var searchvalues=[];
              this.searchvaluesarr=[];
              // searchvalues = this.searching.split(',')
              searchvalues = this.searching.split(/[','|' '|'\n']/)
              for (var i = 0; i < searchvalues.length; i++) {
                this.searchvaluesarr.push(`${searchvalues[i]}`)
              }
              console.log("YYY",this.searchvaluesarr)
          } else{
          this.searchvaluesarr=[];
          }
       
            var csvObj = {
  
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`,
              startdate: `${fromdate}`,
              enddate:`${formatdateto}`,
              warehouseid:warehouseid,
              shipmentstatus:`${shipmentstatus}`,
              page_no:page,
              search_text:this.searchvaluesarr,
              load_movement:this.selected_normalorasn,
             };
           
  
         
          console.log("csvObj",csvObj);
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getMISReportLoadWiseListingNew`, csvObj)
            .then(result => {
              
               this.isBusy = false;
  
              if (result.body.returnmsg  === 'Successful') {
                  this.items  = result.body.returnvalue[0].mislistingresult;
                   this.totalRows = result.body.returnvalue[0].totalrecords;  
                   
             this.noofpages=parseInt(this.totalRows)/20;
             
             this.noofpages=Math.ceil( this.noofpages);  
              }else{
                this.items  = [];
                this.totalRows = 0;               
               
              }
            })
            .catch(ex => {
              console.log("error-----", ex);
            });
      },
  
      downloadCSV:function(){
              document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
          
            // this.isBusy = true;
            
              // var email=this.email;
              var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
              var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
              var warehouseid=(this.valueWH.length>0)? this.valueWH:"";
              var shipmentstatus=(this.shipmentstatus!=null)?this.shipmentstatus:"";
  
              //search
              if (this.searching!= "") {
                  var searchvalues=[];
                  this.searchvaluesarr=[];
                  // searchvalues = this.searching.split(',')
                  searchvalues = this.searching.split(/[','|' '|'\n']/)
                  for (var i = 0; i < searchvalues.length; i++) {
                    this.searchvaluesarr.push(`${searchvalues[i]}`)
                  }
                  console.log("YYY",this.searchvaluesarr)
              }
              
                var csvObj = {
                  sysusermasterid:`${userInfo.sysusermasterid}`,
                  usertype:`${userInfo.user_type}`,
                  warehouseid:warehouseid,
                  // usertype:`${userInfo.user_type}`,
                  startdate: `${fromdate}`,
                  enddate:`${formatdateto}`,
                  // email:`${this.email}`,
                  // page_no:pagee,
                  search_text:this.searchvaluesarr,
                  shipmentstatus:`${shipmentstatus}`,
                  load_movement:this.selected_normalorasn,
                  // sysusermasterid:`${userInfo.sysusermasterid}`
                };
                  console.log("JJJJJ",csvObj);
                // return false;
              if(formatdateto< fromdate){  
                this.$fire({
                        text:"To date need to be greater than From date",
                        type: "warning",
                        timer: 30000
                      }); 
                  document.getElementById("overlay").style.display = "none";
                      // this.isBusy = false; 
                      return false;       
              }
              // console.log("csvObj",csvObj);
              this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getMISReportLoadWiseCsv`, csvObj)
                .then(result => {
                  
                document.getElementById("overlay").style.display = "none";
                if(result.body=="success")
              {
              // alert("Please Check Ur Mail For Downlod Link")
              this.$fire({
                        text:"Please Check Your Mail For Downlod Link",
                        type: "success",
                        timer: 30000
                      }); 
            }
            else
            {
              this.$fire({
                        text:"Can not Download",
                        type: "error",
                        timer: 30000
                      }); 
              // alert("Can not Download");
            }
  
                })
                .catch(ex => {
                  console.log("error-----", ex);
                });
      },
  
      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
  
      },
  
      clear: function() {
     this.searching=[];
     this.searchvaluesarr=[];
     this.selectDateFrom=new Date();
     this.selectDateTo=new Date();
      this.filter="";
      this.valueWH=[];
      this.shipmentstatus="";
      this.selected_normalorasn = 'rocketbees';
       this.showLoadwise(this.pageNum);
      // this.showLoadwise();
     
     
        
      },
     
      MisReportdetails: function(shipmentid,showhide) {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
          var showhides=showhide;
        
   if(showhides)
   {
  
   }
   else{
        
   
   var awbno = shipmentid;
   
  
    var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
          var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
  
         
          var shippingidobj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            serviceid: `${this.hubid}`,
            shippingid: `${awbno}`,
            hub_id:`${userInfo.pickuplocationmasterid}`,
          };
  
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmisreportdetails`,shippingidobj)
          .then(result => {
            this.details = result.body.returnvalue;
            console.log(this.details);
          })
          .catch(ex => {
            console.log('error-----', ex)
          });
        }
      },
  
      showWHlist:function(){
            
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
            
              var csvObj = {};
                console.log("JJJJJ",csvObj);
              // return false;
          
          
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouselisting`, csvObj)
              .then(result => {
                
              if (result.body.returnmsg === 'Successful') {
                this.optionsWH=[];
              
                this.WHData  = result.body.returnvalue;
                console.log("HHHHHHH",this.WHData)
                
            for(let j = 0; j < this.WHData.length; j++) {
                let WH = {
            name: this.WHData[j].warehouseid + " - " + this.WHData[j].warehousename,
            id: this.WHData[j].warehouseid,
          }
          // console.log("hjjjjj",WH.name);
    this.optionsWH.push(WH);
    // console.log("optionsWH",this.optionsWH);
    }
                
              } else {
              
                this.WHData  = result.body.returnvalue;
                
              }
            
  
              })
              .catch(ex => {
                console.log("error-----", ex);
              });
      },
  
  
  
  
    }
  };
  </script>
  
  <style lang="css">
  .popover-container {
    width: 100%;
  }
  .popover-container input {
    -moz-appearance: none;
    -webkit-appearance: none;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 3px;
    -webkit-box-shadow: none;
    box-shadow: none;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 1rem;
    height: 2.25em;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-left: calc(0.625em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    background-color: white;
    border-color: #dbdbdb;
    color: #363636;
    -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    max-width: 100%;
    width: 100%;
  }
  .table tr th {
    color: #fff !important;
    padding: .2rem!important;
  }
  .table thead,
  .table thead tr:hover {
    background: #333 !important;
  }
  .table button {
    background: #b0c4de !important;
    color: #000 !important;
  }
  .table tr:hover {
    background: #efefef;
  }
  tbody tr:nth-child(even) {
    background: #f2f2f2;
  }
  tbody tr:nth-child(odd) {
    background: #fff;
  }
  .registerbox {
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    width: 1244px;
    background-color: #fff;
  }
  hr {
    margin-bottom: 0px;
  }
  .error {
    color: red;
  }
  button.editbtn {
    border: none;
    background: transparent !important;
  }
  .label {
    text-align: left;
  }
  .select {
    width: 100%;
  }
    .nameOfTheClass {
     max-width: 450px !important;
  }
  .orderidClass{
     max-width: 110px !important;
  }
  .awbClass{
    max-width: 110px !important;
  }
  .statusClass{
   max-width: 110px !important; 
  }
  .desitnationClass{
    max-width: 110px !important; 
  }
  .countryClass{
   max-width: 60px !important;  
  }
  .pickupClass{
    max-width: 100px !important; 
  }
  
  
  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  /*tbody tr:nth-child(odd) {
      background: darkgray !important;
  }*/
  </style>
  